import { type KeyboardEvent, type MouseEvent, useId, useState } from 'react';

export default function usePopover() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleKeyboardEvent = (event: KeyboardEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const domId = useId();
  const open = Boolean(anchorEl);
  const id = open ? domId : undefined;

  return { anchorEl, open, id, handleClick, handleKeyboardEvent, handleClose };
}
